const baseUrl= {
     baseUrl: 'https://tradeinmortgage.com/api/',
     baseUrlCP: 'https://tradeinmortgage.com/cp-api/',
     mainUrl: 'https://tradeinmortgage.com',
     postData: 'https://tradeinmortgage.com/cp-api/',
}
export default baseUrl 
